<div fxLayout="row wrap" fxLayoutAlign="center center">
  <h1 class="m-0 p-0">{{ 'component:loading-dialog.loading' | i18nextCap | uppercase }}</h1>
  <mat-icon class="icon-loader ml-1" svgIcon="summa-loader"></mat-icon>
</div>
